import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from 'utils/constants';

export const callShopInfo = async (shopGuid) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop/${shopGuid}`));
};

export const callClientList = async (shopGuid) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop/${shopGuid}/clients`));
};

export const callEditShopInfo = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}`, data));
};

export const callEditShopSalesInfo = async (shopGuid, data) => {
    return await axiosInstance(requestConfig('patch', URL_SYSTEM, `/shop/${shopGuid}`, data));
};

export const callEditShopClientInfo = async (shopGuid, clientGuid, data) => {
    return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop/${shopGuid}/clients/${clientGuid}`, data));
};

export const callShopLocations = async () => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/shop/locations'));
};

export const callAllShopList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/shop?shopTypeCode=shop_type_cd:direct_management&shopTypeCode=shop_type_cd:normal&shopTypeCode=shop_type_cd:tw_normal&shopTypeCode=shop_type_cd:25new_normal&shopTypeCode=shop_type_cd:25ddevice_normal&shopTypeCode=shop_type_cd:25new_private&shopTypeCode=shop_type_cd:bangbae30d_normal&shopTypeCode=shop_type_cd:nzl_normal&shopTypeCode=shop_type_cd:nz_normal&shopTypeCode=shop_type_cd:cn_normal&shopTypeCode=shop_type_cd:hole50kr&shopTypeCode=shop_type_cd:cn_private', null, {}, false, false));
};
